import { AxiosError } from 'axios';

export enum ApiErrorType {
  NETWORK = 'NETWORK',
  AUTH = 'AUTH',
  API_KEY = 'API_KEY',
  CORS = 'CORS',
  TIMEOUT = 'TIMEOUT',
  SERVER = 'SERVER',
  VALIDATION = 'VALIDATION',
  UNKNOWN = 'UNKNOWN',
}

export interface PaginatedResponse<T> {
  items: T[];
  lastEvaluatedKey?: string;
  hasMore?: boolean;
  total?: number;
}

export interface ErrorResponse {
  message: string;
  code?: string;
  details?: any;
}

export interface RequestOptions {
  cancelToken?: any;
  timeout?: number;
}

export interface ApiErrorData {
  message?: string;
  code?: string;
  details?: any;
}

export type UnknownError = Error | AxiosError<ApiErrorData>;

export interface ActResponse {
  id: string;
  title: string;
  description: string;
  source: string;
  sourceDate: string;
  officialId: string;
  category: string;
  shittyVotes: number;
  totalVotes: number;
  shittyPercent: number;
  moderationStatus: string;
  timestamp: number;
}

export interface OfficialResponse {
  id: string;
  name: string;
  title: string;
  position: string;
  state: string;
  jurisdiction: string;
  party: string;
  shittyVotes: number;
  totalVotes: number;
  actCount: number;
  lastUpdated: number;
  createdAt: number;
}

export interface VoteResponse {
  actId: string;
  isShitty: boolean;
  timestamp: number;
  officialId: string;
  actDetails?: {
    title: string;
    shittyVotes: number;
    totalVotes: number;
    shittyPercent: number;
  };
}